import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SectionHeader } from '@grnhse/seedling/lib/birch/typography';
import { useUserContext, TABS } from 'talent_matching/contexts/user_context';

const MyGreenhousePageContent = () => {
  const { activeTab } = useUserContext();
  const isActive = activeTab === TABS.MY_GREENHOUSE;

  return (
    <Stack spacing={0}>
      {isActive && <SectionHeader>{'MyGreenhouse Discovery'}</SectionHeader>}
    </Stack>
  );
};

export default MyGreenhousePageContent;
